import { LocalStore } from 'zf-web-infra';
import { AG_GRID_LOCALE_CN } from './zh-CN';
import { AG_GRID_LOCALE_HK } from './zh-HK';
import { AG_GRID_LOCALE_JP } from './ja-JP';
import { AG_GRID_LOCALE_TW } from './zh-TW';

/**
 * 基础数据拷贝自
 * https://www.ag-grid.com/react-data-grid/localisation/
 */
export class Locale {

  private readonly store = new LocalStore();

  getLocale(): Record<string, string> {
    if (this.store.lang === 'zh_cn') {
      return AG_GRID_LOCALE_CN;
    }
    if (this.store.lang === 'zh_hk') {
      return AG_GRID_LOCALE_HK;
    }
    if (this.store.lang === 'jp') {
      return AG_GRID_LOCALE_JP;
    }
    if (this.store.lang === 'zh_tw') {
      return AG_GRID_LOCALE_TW;
    }
    return {};
  }

}

export const locale = new Locale();
